import { FrontendApplicationConfigProvider } from '@theia/core/lib/browser/frontend-application-config-provider';
import { WindowTitleService } from '@theia/core/lib/browser/window/window-title-service';
import { injectable } from '@theia/core/shared/inversify';

@injectable()
export class OnlinePreviewWindowTitleService extends WindowTitleService {
    protected override updateTitle(): void {
        // Online Preview has a product-level page title, so persisted Theia title preferences must not add view names.
        const title: string = FrontendApplicationConfigProvider.get().applicationName;
        if (this._title === title && document.title === title) return;

        this._title = title;
        document.title = title;
        this.onDidChangeTitleEmitter.fire(title);
    }
}
